var map = {
	"./AOSTA.png": "a1e0",
	"./BARI.png": "fde1",
	"./BOLOGNA.png": "1c00",
	"./CAGLIARI.png": "76ef",
	"./CAMPOBASSO.png": "09d5",
	"./CATANZARO.png": "2f21",
	"./FIRENZE.png": "9d1b",
	"./GENOVA.png": "e505",
	"./MILANO.png": "1f6a",
	"./NAPOLI.png": "8bbd",
	"./PALERMO.png": "210e",
	"./PERUGIA.png": "b4eb",
	"./POTENZA.png": "7af0",
	"./ROMA.png": "f506",
	"./TORINO.png": "701e",
	"./TRENTO.png": "6b63",
	"./TRIESTE.png": "f7ea",
	"./VENEZIA.png": "3e54",
	"./icone.png": "e579"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1a9f";